import React from 'react'
import InputWithLabel from './../../../../commons/InputWithLabel'

class Credit extends React.Component {
  onChange = (params) => {
    this.props.onChange(params)
  }

  render() {
    const {
      creditLimit,
      outstandingBalance,
      provider,
      owner,
      repaymentWay,
      errors,
      option
    } = this.props.commitment

    return(
      <div className='card-body'>
        <InputWithLabel
          label="Outstanding balance"
          type='currency'
          defaultValue={ outstandingBalance }
          errorMessage={ errors['outstandingBalance'] }
          onChange={ (value) => { this.onChange({outstandingBalance: value}) } }
        />
        <InputWithLabel
          label="Credit limit"
          type='currency'
          defaultValue={ creditLimit }
          errorMessage={ errors['creditLimit'] }
          onChange={ (value) => { this.onChange({creditLimit: value}) } }
        />

        {option === 'credit_card' ?
          <InputWithLabel
            label='Typical way of repayment'
            type='select'
            borderStyle='responsive'
            defaultValue={repaymentWay}
            errorMessage={errors['repaymentWay']}
            options={this.props.availableRepaymentWays}
            onChange={(value) => { this.onChange({repaymentWay: value}); }}
          /> : null
        }

        <InputWithLabel
          label='Provider'
          type='select'
          borderStyle='responsive'
          defaultValue={ provider }
          errorMessage={ errors['provider'] }
          options={ this.props.availableProviders }
          onChange={ (value) => { this.onChange({provider: value}) } }
        />
      {this.props.ownerOptions.length > 0 &&
        <InputWithLabel
          label='Owner'
          type='select'
          borderStyle='responsive'
          defaultValue={ owner }
          errorMessage={ errors['owner'] }
          options={ this.props.ownerOptions }
          onChange={ (value) => { this.onChange({owner: value}) } }
        />
      }
      </div>
    )
  }
}

export default Credit;
